import LatestWorkLayout from "../../../../src/templates/latestWork/LatestWork.component.js";
import * as React from 'react';
export default {
  LatestWorkLayout,
  React
};